/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {EtlConf} from '../model/etlConf';
import {EtlDesignDTO} from '../model/etlDesignDTO';
import {EtlFilterDTO} from '../model/etlFilterDTO';
import {EtlSetupDTO} from '../model/etlSetupDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {EtlScriptDTO} from "../model/etlScriptDTO";
import {EtlExportSearchDTO} from "../model/etlExportSearchDTO";
import {EtlExportParamDTO} from "../model/etlExportParamDTO";
import {EtlDuplicateDTO} from "../model/etlDuplicateDTO";
import {EtlExportDescDTO} from "../model/etlExportDescDTO";
import {KeyValue} from "@angular/common";


@Injectable()
export class ConfiguratorEtlService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Ajouter un fichier de Setup à un Etl
     * Cette requête permet de designer un Etl par son identifiant et lui ajouter un fichier de setup.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param file file
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSetupFileUsingPOST(xDataStoreID: string, file: Blob, id: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public addSetupFileUsingPOST(xDataStoreID: string, file: Blob, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public addSetupFileUsingPOST(xDataStoreID: string, file: Blob, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public addSetupFileUsingPOST(xDataStoreID: string, file: Blob, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling addSetupFileUsingPOST.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling addSetupFileUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addSetupFileUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = <any>formParams.append('file', <any>file) || formParams;
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/setup/file`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un Etl par son identifiant
     * Cette requête permet de supprimer un Etl par son identifiant.&lt;br&gt;Si la requête reussit, la réponse contient le code de succès 204.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEtlByIdUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEtlByIdUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEtlByIdUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEtlByIdUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteEtlByIdUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteEtlByIdUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les Etls
     * Cette requête permet de lister les Etls.&lt;br&gt;On retrouve dans le corps de la réponse une liste des Etls et le code 200, si la requête a bien marché.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID
     * @param type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllEtls(xDataStoreID: string, type?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<EtlConf>>;
    public getAllEtls(xDataStoreID: string, type?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EtlConf>>>;
    public getAllEtls(xDataStoreID: string, type?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EtlConf>>>;
    public getAllEtls(xDataStoreID: string, type?: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllEtls.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (type) {
            type.forEach((element) => {
                queryParameters = queryParameters.append('type', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<EtlConf>>('get',`${this.basePath}/api/etls`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un Design Etl par son identifiant
     * Cette requête permet de récupérer le Design d&#39;un Etl par son identifiant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDesignUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlDesignDTO>;
    public getDesignUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlDesignDTO>>;
    public getDesignUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlDesignDTO>>;
    public getDesignUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDesignUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDesignUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlDesignDTO>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/design`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un Etl par son identifiant
     * Cette requête permet de récupérer un Etl par son identifiant.&lt;br&gt;Si l&#39;identifiant fourni correspond à un Etl, la réponse contient cet objet et le code de succès 200.&lt;br&gt;Si l&#39;identifiant fourni ne correspond à aucun Etl, la réponse contient le code d&#39;erreur 404.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEtlByIdUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public getEtlByIdUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public getEtlByIdUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public getEtlByIdUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getEtlByIdUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEtlByIdUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlConf>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupèrer un Etl par son code
     * Cette requête permet de récupérer un Etl par son code.&lt;br&gt;Si le code fourni correspond à un Etl, la réponse contient cet objet et le code de succès 200.&lt;br&gt;Si le code fourni ne correspond à aucun Etl, la réponse contient le code d&#39;erreur 404.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEtlUsingGET(xDataStoreID: string, code: string, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public getEtlUsingGET(xDataStoreID: string, code: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public getEtlUsingGET(xDataStoreID: string, code: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public getEtlUsingGET(xDataStoreID: string, code: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getEtlUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getEtlUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlConf>(`${this.basePath}/api/etls/code/${encodeURIComponent(String(code))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un Filter Etl par son identifiant
     * Cette requête permet de récupérer le Filter d&#39;un Etl par son identifiant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilterUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlFilterDTO>;
    public getFilterUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlFilterDTO>>;
    public getFilterUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlFilterDTO>>;
    public getFilterUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getFilterUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getFilterUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlFilterDTO>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/filter`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un Setup Etl par son identifiant
     * Cette requête permet de récupérer un Setup Etl par son identifiant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSetupUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlSetupDTO>;
    public getSetupUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlSetupDTO>>;
    public getSetupUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlSetupDTO>>;
    public getSetupUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getSetupUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getSetupUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlSetupDTO>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/setup`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sauvegarder un Etl par son identifiant
     * Cette requête permet de sauvegarder un Etl par son identifiant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etl etl
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveEtlByIdUsingPOST(xDataStoreID: string, etl: EtlConf, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public saveEtlByIdUsingPOST(xDataStoreID: string, etl: EtlConf, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public saveEtlByIdUsingPOST(xDataStoreID: string, etl: EtlConf, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public saveEtlByIdUsingPOST(xDataStoreID: string, etl: EtlConf, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling saveEtlByIdUsingPOST.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling saveEtlByIdUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling saveEtlByIdUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlConf>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}`,
            etl,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sauvegarder un Etl par son identifiant
     * Cette requête permet de sauvegarder un Etl par son identifiant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etl etl
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveEtlUsingPOST(xDataStoreID: string, etl: EtlConf, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public saveEtlUsingPOST(xDataStoreID: string, etl: EtlConf, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public saveEtlUsingPOST(xDataStoreID: string, etl: EtlConf, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public saveEtlUsingPOST(xDataStoreID: string, etl: EtlConf, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling saveEtlByIdUsingPOST.');
        }

        if (etl === null || etl === undefined) {
            throw new Error('Required parameter etl was null or undefined when calling saveEtlByIdUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlConf>(`${this.basePath}/api/etls/new`,
            etl,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dupliquer un Etl
     * Cette requête crée une copie de l&#39;Etl sous le code, le nom et les affiliés fournis. La copie reprend
     * tout le reste de l&#39;Etl source, y compris ses secrets, sans que ceux-ci transitent par le client.
     * La réponse ne contient pas les secrets.
     * @param xDataStoreID X-DataStoreID
     * @param id id de l&#39;Etl source
     * @param body ce qui change dans la copie
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateEtlUsingPOST(xDataStoreID: string, id: string, body: EtlDuplicateDTO, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public duplicateEtlUsingPOST(xDataStoreID: string, id: string, body: EtlDuplicateDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public duplicateEtlUsingPOST(xDataStoreID: string, id: string, body: EtlDuplicateDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public duplicateEtlUsingPOST(xDataStoreID: string, id: string, body: EtlDuplicateDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling duplicateEtlUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateEtlUsingPOST.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling duplicateEtlUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlConf>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/duplicate`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Activer/désactiver le planification d&#39;un Etl
     * Cette requête permet d&#39;activer/désactiver le planification d&#39;un Etl.
     * @param xDataStoreID X-DataStoreID
     * @param enable enable
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setScheduleUsingGET(xDataStoreID: string, enable: boolean, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setScheduleUsingGET(xDataStoreID: string, enable: boolean, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setScheduleUsingGET(xDataStoreID: string, enable: boolean, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setScheduleUsingGET(xDataStoreID: string, enable: boolean, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling setScheduleUsingGET.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling setScheduleUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setScheduleUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any> enable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<any>(`${this.basePath}/api/etls/${encodeURIComponent(String(id))}/schedule`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un Design Etl
     * Cette requête permet de modifier un Design Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etlDesignDTO etlDesignDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDesignUsingPOST(xDataStoreID: string, etlDesignDTO: EtlDesignDTO, observe?: 'body', reportProgress?: boolean): Observable<EtlDesignDTO>;
    public updateDesignUsingPOST(xDataStoreID: string, etlDesignDTO: EtlDesignDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlDesignDTO>>;
    public updateDesignUsingPOST(xDataStoreID: string, etlDesignDTO: EtlDesignDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlDesignDTO>>;
    public updateDesignUsingPOST(xDataStoreID: string, etlDesignDTO: EtlDesignDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateDesignUsingPOST.');
        }

        if (etlDesignDTO === null || etlDesignDTO === undefined) {
            throw new Error('Required parameter etlDesignDTO was null or undefined when calling updateDesignUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlDesignDTO>(`${this.basePath}/api/etls/design`,
            etlDesignDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un Filter Etl
     * Cette requête permet de modifier un Filter Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etlFilterDTO etlFilterDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFilterUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'body', reportProgress?: boolean): Observable<EtlFilterDTO>;
    public updateFilterUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlFilterDTO>>;
    public updateFilterUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlFilterDTO>>;
    public updateFilterUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateFilterUsingPOST.');
        }

        if (etlFilterDTO === null || etlFilterDTO === undefined) {
            throw new Error('Required parameter etlFilterDTO was null or undefined when calling updateFilterUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlFilterDTO>(`${this.basePath}/api/etls/filter`,
            etlFilterDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un Process Etl
     * Cette requête permet de modifier un Process Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etlFilterDTO etlFilterDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateProcessUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'body', reportProgress?: boolean): Observable<EtlFilterDTO>;
    public updateProcessUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlFilterDTO>>;
    public updateProcessUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlFilterDTO>>;
    public updateProcessUsingPOST(xDataStoreID: string, etlFilterDTO: EtlFilterDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateProcessUsingPOST.');
        }

        if (etlFilterDTO === null || etlFilterDTO === undefined) {
            throw new Error('Required parameter etlFilterDTO was null or undefined when calling updateProcessUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EtlFilterDTO>(`${this.basePath}/api/etls/process`,
            etlFilterDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un Setup Etl
     * Cette requête permet de modifier un Setup Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param etlSetup etlSetup
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSetupUsingPOST(xDataStoreID: string, etlSetup: EtlSetupDTO, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public updateSetupUsingPOST(xDataStoreID: string, etlSetup: EtlSetupDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public updateSetupUsingPOST(xDataStoreID: string, etlSetup: EtlSetupDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public updateSetupUsingPOST(xDataStoreID: string, etlSetup: EtlSetupDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateSetupUsingPOST.');
        }

        if (etlSetup === null || etlSetup === undefined) {
            throw new Error('Required parameter etlSetup was null or undefined when calling updateSetupUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/etls/setup`,
            etlSetup,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'text' as 'json'
            }
        );
    }

    /**
     * Exporter un Etl sous le format JSON
     * Cette requête permet d&#x27;exporter un Etl au format JSON.&lt;br&gt;Si l'id fourni correspond à un Etl, la réponse contient l&#x27;export des paramètres de l&#x27;etl au format json et le code de succès 200.&lt;br&gt;Si l'id fourni ne correspond à aucun Etl, la réponse contient le code d&#x27;erreur 404.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param id
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportEtl(id: string, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public exportEtl(id: string, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public exportEtl(id: string, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public exportEtl(id: string, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter code was null or undefined when calling exportEtl.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportEtl.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/api/etls/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter plusieurs Etl sous le format JSON dans un format ZIP
     * Cette requête permet d&#x27;exporter un Etl au format JSON.&lt;br&gt;Si les ids fournis correspond à un Etl, la réponse contient l&#x27;export des paramètres de l&#x27;etl au format json dans une archive zip et le code de succès 200.&lt;br&gt;Si les ids fournis ne correspondent à aucun Etl, la réponse contient le code d&#x27;erreur 404.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param ids
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public exportEtlInZip(ids: string[], xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportEtlInZip(ids: string[], xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportEtlInZip(ids: string[], xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportEtlInZip(ids: string[], xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter code was null or undefined when calling exportEtlInZip.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportEtlInZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/zip',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get', `${this.basePath}/api/etls/export/zip/${encodeURIComponent(String(ids))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }


    /**
     * Importer un Etl
     * Cette requête permet d&#x27;importer un Etl.&lt;br&gt;Si le code de l&#x27;etl n&#x27;est pas utilisé par un autre elt enregistré dans mongoDB, l&#x27;elt est enregistré et le code de succès 200.&lt;br&gt;Si un code d&#x27;erreur 500 est envoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importEtlFromJson(body: string, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public importEtlFromJson(body: string, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public importEtlFromJson(body: string, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public importEtlFromJson(body: string, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importEtl.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importEtl.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/etls/import/json/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer un Etl
     * Cette requête permet d&#x27;importer un Etl.&lt;br&gt;Si le code de l&#x27;etl n&#x27;est pas utilisé par un autre elt enregistré dans mongoDB, l&#x27;elt est enregistré et le code de succès 200.&lt;br&gt;Si un code d&#x27;erreur 500 est envoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importEtlFromZip(body: FormData, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public importEtlFromZip(body: FormData, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public importEtlFromZip(body: FormData, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public importEtlFromZip(body: FormData, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importEtl.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importEtl.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/etls/import/zip/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Enregistre un Etl de type script
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateScriptExport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateScriptExport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateScriptExport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateScriptExport(body: EtlScriptDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateScriptExport.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateScriptExport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/etls/script/export`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * récupère un Etl de type script
     *
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExport(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlScriptDTO>;
    public getScriptExport(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlScriptDTO>>;
    public getScriptExport(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlScriptDTO>>;
    public getScriptExport(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getScriptExport.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getScriptExport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EtlScriptDTO>('get',`${this.basePath}/api/etls/script/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * récupère un Etl de type script
     *
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptImport(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlScriptDTO>;
    public getScriptImport(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlScriptDTO>>;
    public getScriptImport(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlScriptDTO>>;
    public getScriptImport(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getScriptImport.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getScriptImport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EtlScriptDTO>('get',`${this.basePath}/api/etls/script/import/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * Enregistre un Etl de type script
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateScriptImport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateScriptImport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateScriptImport(body: EtlScriptDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateScriptImport(body: EtlScriptDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateScriptImport.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateScriptImport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/etls/script/import`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier l&#x27;export-descrption Etl
     * Cette requête permet de modifier un l&#x27;export-descrption Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateExportDescription(body: EtlExportDescDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<KeyValue<string, string>>;
    public updateExportDescription(body: EtlExportDescDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KeyValue<string, string>>>;
    public updateExportDescription(body: EtlExportDescDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KeyValue<string, string>>>;
    public updateExportDescription(body: EtlExportDescDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateExportDescription.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateExportDescription.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<KeyValue<string, string>>('post', `${this.basePath}/api/etls-export/description`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier l&#x27;export-search Etl
     * Cette requête permet de modifier un l&#x27;export-search Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateExportParam(body: EtlExportParamDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateExportParam(body: EtlExportParamDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateExportParam(body: EtlExportParamDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateExportParam(body: EtlExportParamDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateExportParam.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateExportParam.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post', `${this.basePath}/api/etls-export/param`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier l&#x27;export-search Etl
     * Cette requête permet de modifier un l&#x27;export-search Etl.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateExportSearch(body: EtlExportSearchDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateExportSearch(body: EtlExportSearchDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateExportSearch(body: EtlExportSearchDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateExportSearch(body: EtlExportSearchDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateExportSearch.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateExportSearch.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post', `${this.basePath}/api/etls-export/search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Re-parser le fichier existant d'un Etl
     * Cette requête permet de re-parser le fichier déjà stocké d'un Etl avec les nouveaux paramètres hasHeaderRow.&lt;br&gt;Utile quand l'utilisateur change l'option 'contient une ligne d'entête' sans re-uploader le fichier.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre X_DATASTORE_ID est le code qui correspond au datastore(tenant).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reparseFileUsingPOST(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public reparseFileUsingPOST(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public reparseFileUsingPOST(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public reparseFileUsingPOST(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling reparseFileUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reparseFileUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<boolean>('post', `${this.basePath}/api/etls/${encodeURIComponent(String(id))}/setup/reparse`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
